import { store } from '../store'
import { del, patch, post } from '../api'

export const createColor = async (params) => {
  try {
    store.setState({ isUpdatingProject: true })
    const projectId = store.getState().project.id
    const { data: project } = await post(`/projects/${projectId}/colors`, params)
    const refreshVersion = (store.getState().refreshVersion || 0) + 1
    store.setState({ project, refreshVersion, isUpdatingProject: false })
    return project
  } catch (error) {
    store.setState({ error, isUpdatingProject: false })
  }
}

export const updateColor = async (colorId, params) => {
  try {
    store.setState({ isUpdatingProject: true })
    const projectId = store.getState().project.id
    const { data: project } = await patch(`/projects/${projectId}/colors/${colorId}`, params)
    const refreshVersion = (store.getState().refreshVersion || 0) + 1
    store.setState({ project, refreshVersion, isUpdatingProject: false })
    return project
  } catch (error) {
    store.setState({ error, isUpdatingProject: false })
  }
}

export const deleteColor = async (colorId) => {
  try {
    store.setState({ isUpdatingProject: true })
    const projectId = store.getState().project.id
    const { data: project } = await del(`/projects/${projectId}/colors/${colorId}`)
    const refreshVersion = (store.getState().refreshVersion || 0) + 1
    store.setState({ project, refreshVersion, isUpdatingProject: false })
    return project
  } catch (error) {
    store.setState({ error, isUpdatingProject: false })
  }
}

export const moveColorUp = async (colorId) => {
  try {
    store.setState({ isUpdatingProject: true })
    const projectId = store.getState().project.id
    const { data: project } = await post(`/projects/${projectId}/colors/${colorId}/move-up`)
    const refreshVersion = (store.getState().refreshVersion || 0) + 1
    store.setState({ project, refreshVersion, isUpdatingProject: false })
    return project
  } catch (error) {
    store.setState({ error, isUpdatingProject: false })
  }
}

export const moveColorDown = async (colorId) => {
  try {
    store.setState({ isUpdatingProject: true })
    const projectId = store.getState().project.id
    const { data: project } = await post(`/projects/${projectId}/colors/${colorId}/move-down`)
    const refreshVersion = (store.getState().refreshVersion || 0) + 1
    store.setState({ project, refreshVersion, isUpdatingProject: false })
    return project
  } catch (error) {
    store.setState({ error, isUpdatingProject: false })
  }
}
